import { render } from "./SupplierCreate.vue?vue&type=template&id=3ebcaa1d&scoped=true"
import script from "./SupplierCreate.vue?vue&type=script&lang=ts"
export * from "./SupplierCreate.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3ebcaa1d"

export default script